import { useEffect } from "react";
import {
  Button,
  Col,
  Container,
  FloatingLabel,
  Placeholder,
  Row,
} from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { getLocal, NFeDto, STORAGENFE_KEY, updateLocal } from "../NFe.Dto";
import NFeConfiguracaoCode from "../NFe.Configuracao.Code";
import { TipoConfiguracaoEnum } from "src/pages/Privada/Configuracoes/Sistema/Sistema.Dto";

const NFeCadastroOperacaoView = () => {
  const navigate = useNavigate();
  const configuracao = NFeConfiguracaoCode();

  const operacaoSelecionado = () =>
    getLocal<NFeDto>(STORAGENFE_KEY)?.tipoOperacao ?? undefined;

  const selecionado = operacaoSelecionado() != undefined;

  // Atribui a série automaticamente para nova NF-e assim que a configuração for carregada
  useEffect(() => {
    if (!configuracao.loading) {
      const serieValor = configuracao.getConfiguracaoValor(
        TipoConfiguracaoEnum.Serie
      );
      const serieNum = Number(serieValor);
      if (serieNum > 0) {
        const nf = getLocal<NFeDto>(STORAGENFE_KEY);
        const isEdicao = Boolean(nf?.id && nf.id > 0);
        if (!isEdicao || !nf?.serie) {
          updateLocal<NFeDto>(STORAGENFE_KEY, {
            serie: serieNum,
          });
        }
      }
    }
  }, [configuracao.loading]);

  const handleSalvar = (operacao: number) => () => {
    const serieValor = configuracao.getConfiguracaoValor(
      TipoConfiguracaoEnum.Serie
    );
    const serieNum = Number(serieValor);

    updateLocal<NFeDto>(STORAGENFE_KEY, {
      tipoOperacao: operacao,
      tributacaoId: undefined,
      finalidadeEmissao: 1,
      serie: serieNum > 0 ? serieNum : undefined,
    });
    handleProximo();
  };

  const handleProximo = () => {
    const serieValor = configuracao.getConfiguracaoValor(
      TipoConfiguracaoEnum.Serie
    );
    const serieNum = Number(serieValor);
    const nf = getLocal<NFeDto>(STORAGENFE_KEY);
    const isEdicao = Boolean(nf?.id && nf.id > 0);

    if ((!isEdicao || !nf?.serie) && serieNum > 0) {
      updateLocal<NFeDto>(STORAGENFE_KEY, {
        serie: serieNum,
      });
    }

    navigate("../finalidade");
  };

  const buttonVariant = (operacao: number) => {
    const destino = operacaoSelecionado();

    if (destino === operacao) {
      return "primary";
    }

    return "outline-primary";
  };

  return (
    <>
      {!configuracao.loading ? (
        <>
          <Row>
            <Col xs={12} className="d-grid mt-3">
              <Button
                type="submit"
                onClick={handleSalvar(1)}
                variant={buttonVariant(1)}
              >
                Saída
              </Button>
            </Col>
          </Row>
          <Row>
            <Col xs={12} className="d-grid mt-3">
              <Button
                type="submit"
                onClick={handleSalvar(0)}
                variant={buttonVariant(0)}
              >
                Entrada
              </Button>
            </Col>
          </Row>
          {selecionado && (
            <div className="fixed-bottom">
              <Container className="py-3">
                <Row>
                  <Col xs={12} className="d-grid">
                    <Button
                      variant="outline-primary"
                      type="submit"
                      onClick={handleProximo}
                    >
                      Próximo
                    </Button>
                  </Col>
                </Row>
              </Container>
            </div>
          )}
        </>
      ) : (
        <Placeholder as={FloatingLabel} animation="glow">
          <Placeholder xs={12} />
        </Placeholder>
      )}
    </>
  );
};
export default NFeCadastroOperacaoView;
